/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
} from './Criteria';

/**
 * 
 * @export
 * @interface CreateGlobalCriteria201Response
 */
export interface CreateGlobalCriteria201Response {
    /**
     * 
     * @type {Criteria}
     * @memberof CreateGlobalCriteria201Response
     */
    data?: Criteria;
}

/**
 * Check if a given object implements the CreateGlobalCriteria201Response interface.
 */
export function instanceOfCreateGlobalCriteria201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateGlobalCriteria201ResponseFromJSON(json: any): CreateGlobalCriteria201Response {
    return CreateGlobalCriteria201ResponseFromJSONTyped(json, false);
}

export function CreateGlobalCriteria201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGlobalCriteria201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CriteriaFromJSON(json['data']),
    };
}

export function CreateGlobalCriteria201ResponseToJSON(value?: CreateGlobalCriteria201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CriteriaToJSON(value.data),
    };
}

